<template>
  <div class="modal fade" id="changeReservationStatusModal" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="changeOrderStatusModalLabel">Change Reservation Status</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control" v-model="selectedStatus" :disabled="disableUpdateBtn">
              <option disabled selected value="-1">Select status</option>
              <option v-for="status in updatedStatuses" v-bind:key="'statuses_'+status.id"
                      v-bind:value="status.id">{{ status.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-warning" @click="repushReservation()" :disabled="disableRepushButton">Re-push</button>
          <button type="button" v-bind:disabled="disableButton" v-on:click="updateReservationStatus()"
                  class="btn btn-primary" :disabled="disableUpdateBtn">Update Status
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {addNewReservations, rePushReservations} from "@/api/reservations";

export default {
  name: "ChangeStatusOfReservation",
  data: function () {
    return {
      reservationId: -1,
      currentStatus: null,
      selectedStatus: -1,
      disableButton: false,
      disableRepushButton: false,
      updatedStatuses: [],
    }
  },
  props: {
    statuses: Array,
  },
  computed: {
    disableUpdateBtn() {
      return this.currentStatus === 1 || this.currentStatus === 9
    }
  },
  mounted() {
    $("#changeReservationStatusModal").on('hidden.bs.modal', (e) => {
      this.selectedStatus = -1;
      this.disableButton = false;
    });
    this.updatedStatuses = this.statuses
  },
  methods: {
    load (id, currentStatus) {
      this.reservationId = id
      this.currentStatus = Number(currentStatus)
      switch (this.currentStatus) {
        case 7:
          this.updatedStatuses = this.statuses.filter(status => status.id === 1 || status.id === 9);
          break;
        case 1:
          this.updatedStatuses = this.statuses.filter(status => status.id === 2 || status.id === 9);
          break;
        case 2:
          this.updatedStatuses = this.statuses.filter(status => status.id === 9);
          break;
      }
      $("#changeReservationStatusModal").modal("show");
    },
    updateReservationStatus: function () {
      let params = new URLSearchParams();
      if (this.selectedStatus === -1) {
        return swal("Error!", "Please select status", "error");
      }
      this.disableButton = true;
      params.append("status_id", this.selectedStatus);
      params.append("reservation_id", this.reservationId);
      this.$http.post(this.$store.state.mainAppURL + "reservations/update_status", params).then(resp => {
        if (resp.data) {
          swal("SUCCESS!", "Status has been updated!", "success");
          this.$parent.dtTable.draw()
          $("#changeReservationStatusModal").modal("hide");
        }

      });
    },
    async repushReservation() {
      this.disableRepushButton = true
      try {
        await rePushReservations(this.reservationId);
        swal("SUCCESS!", "Reservation re-pushed successfully!", "success");
      } catch (e) {
        this.showErrorMessage(e)
      }
      this.disableRepushButton = false
    }

  }
}
</script>

<style scoped>

</style>